enum LEVEL_COLOR {
  log = '#006fff',
  info = '#815eff',
  warn = '#ffd000',
  debug = '#33ff00',
  error = '#ff0000',
}

export class Logger {
  private readonly module: string;
  private readonly subModule?: string;
  constructor(module: string, subModule?: string) {
    this.module = module;
    if (subModule) {
      this.subModule = subModule;
    }
  }
  _log(level: string, ...args: any[]) {
    if (typeof console[level] !== 'function') {
      level = 'log';
    }
    if (this.subModule) {
      console[level](
        `%c ${this.module} %c ${this.subModule}`,
        'padding: 2px 1px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;',
        `padding: 2px 1px; border-radius: 0 3px 3px 0; color: #fff; background: ${LEVEL_COLOR[level]}; font-weight: bold;`,
        ...args
      );
    } else {
      console[level](
        `%c ${this.module}`,
        `padding: 2px 1px; border-radius: 3px; color: #fff; background: ${LEVEL_COLOR[level]}; font-weight: bold;`,
        ...args
      );
    }
  }
  info(...args: any[]) {
    this._log('info', ...args);
  }

  warn(...args: any[]) {
    this._log('warn', ...args);
  }

  debug(...args: any[]) {
    this._log('debug', ...args);
  }

  error(...args: any[]) {
    this._log('error', ...args);
  }

  log(...args: any[]) {
    this._log('log', ...args);
  }

  createSubLogger(subModule: string) {
    return new Logger(this.module, subModule);
  }
}

export const logger = new Logger('CrashReport');
